import routePath from '@src/lib/routePath'

const organicCampaignPaths = {
  details: routePath(
    `/retailer/campaigns/:retailerAccountSlug/:campaignId/:channel?`,
  ),
  legacyDetails: routePath(
    `/#/:retailerAccountSlug/:brandSlug/campaigns/:campaignId/activate/:channel?`,
  ),
}

export default organicCampaignPaths
